(() => {
  // app/scripts/pickup-availability.js
  if (!customElements.get("pickup-availability")) {
    customElements.define("pickup-availability", class PickupAvailability extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        if (!this.hasAttribute("available"))
          return;
        this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.observer = new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting)
            return;
          observer.unobserve(this);
          this.isIntersecting = true;
          this.fetchAvailability(this.dataset.variantId);
        }, { rootMargin: "400px 0px 400px 0px" });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (!this.hasAttribute("available"))
          return;
        if (!this.isIntersecting)
          this.observer?.unobserve(this);
      }
      fetchAvailability(variantId) {
        const variantSectionUrl = `${window.Shopify.routes.root}variants/${variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl).then((response) => response.text()).then((text) => {
          const parsedHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
          this.renderPreview(parsedHTML, variantId);
        }).catch((e) => {
          console.log("fetchAvailability::error::", e);
          const button = this.querySelector("button");
          if (button)
            button.removeEventListener("click", this.onClickRefreshList);
          this.renderError();
        });
      }
      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }
      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.querySelector("button").addEventListener("click", this.onClickRefreshList);
      }
      renderPreview(html, variantId) {
        const popup = document.querySelector(`#pickup-availability-popup-${variantId}`);
        if (popup)
          popup.remove();
        if (!html.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }
        this.innerHTML = html.querySelector("pickup-availability-preview").outerHTML;
        this.setAttribute("available", "");
        document.body.appendChild(html.querySelector(`#pickup-availability-popup-${variantId}`));
        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            document.querySelector(`#pickup-availability-popup-${variantId}`).open();
          });
      }
      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }
    });
  }
})();
